export class DictReasonWanted {
  id:number;
  name:string;
}
